import MobileTabsHeader from 'components/TabsHeader/MobileTabsHeader';
import TabsHeader from 'components/TabsHeader/TabsHeader';
import { useEffect, useRef } from 'react';
import { Container } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { NAVIGATION_STYLES } from 'store/config/displayOptions.config';
import { selectNavigationStyle } from 'store/selectors/DisplayOptions/displayOptionsSelectors';
import About from './About';
import AccessibilitySettings from './AccessibilitySettings';
import AccountSettings from './AccountSettings';
import ClassicAbout from './classic/ClassicAbout';
import ClassicAccessibilitySettings from './classic/ClassicAccessibilitySettings';
import { ClassicUserInfo } from './classic/ClassicUserInfo';
import { ClassicUserPlaces } from './classic/ClassicUserPlaces';
import { UserPlaces } from './UserPlaces';

// The Navigation display setting also picks the look of these pages: Merlin Slate, or Classic.
const TABS = {
  [NAVIGATION_STYLES.MERLIN]: {
    account: AccountSettings,
    places: UserPlaces,
    accessibility: AccessibilitySettings,
    about: About,
  },
  [NAVIGATION_STYLES.CLASSIC]: {
    account: ClassicUserInfo,
    places: ClassicUserPlaces,
    accessibility: ClassicAccessibilitySettings,
    about: ClassicAbout,
  },
};

export default function UserMenu() {
  const [searchParams] = useSearchParams();
  const navigationStyle = useSelector(selectNavigationStyle);
  const previousNavigationStyle = useRef(navigationStyle);

  // Picking the other Navigation style swaps this page for its other version, which drops the
  // focused Navigation select; put focus back on the new page's Navigation select.
  useEffect(() => {
    if (previousNavigationStyle.current === navigationStyle) return;
    previousNavigationStyle.current = navigationStyle;
    document.querySelector('input[aria-label="Navigation"]')?.focus();
  }, [navigationStyle]);

  const renderTab = () => {
    const tabs = TABS[navigationStyle] ?? TABS[NAVIGATION_STYLES.MERLIN];
    const key = searchParams.get('tab')?.toLowerCase();
    // Own keys only: `?tab=constructor` must fall back to Account, not render an Object.
    const Tab = key && Object.hasOwn(tabs, key) ? tabs[key] : tabs.account;
    return <Tab />;
  };

  return (
    <Container fluid className="d-flex flex-column pb-3">
      {/* header */}
      <div className="d-none d-lg-block flex-shrink-0">
        <TabsHeader
          options={[
            { option: 'Account' },
            { option: 'Places' },
            { option: 'Accessibility' },
            { option: 'About' },
          ]}
        />
      </div>
      <div className="d-block d-lg-none flex-shrink-0">
        <MobileTabsHeader
          options={[
            { option: 'Account' },
            { option: 'Places' },
            { option: 'Accessibility' },
            { option: 'About' },
          ]}
        />
      </div>
      {/* content */}
      <div className="px-2 px-md-3 overflow-x-hidden">{renderTab()}</div>
    </Container>
  );
}
